if (typeof boostPFSThemeConfig !== 'undefined') {
	// Override Settings
	var boostPFSFilterConfig = {
    	general: {
    		limit: boostPFSConfig.custom.products_per_page,
    		// Optional
    		loadProductFirst: true,
    		styleScrollToTop: 'style2',
    		paginationType: boostPFSConfig.custom.use_infinite_scroll ? 'infinite' : 'default',
    	}
    };
}

var boostPFSTemplate = {
	'saleLabel': '<div class="on-sale">' + boostPFSConfig.label.sale + '</div>',
	'soldOutLabel': '<div class="sold-out">' + boostPFSConfig.label.sold_out + '</div>',

  	// Grid Template
	'productGridItemHtml': '<div data-boost-theme-quickview="{{itemId}}" data-product-id="{{itemId}}" class="col-md-' + boostPFSConfig.custom.grid_item_width + ' col-xs-6 element mb30">' +
							   '<div class="main_box {{itemOverlayClass}}">' +
									'<div class="box_1">' +
										'{{itemSaleLabel}}' +
										'{{itemSoldOutLabel}}' +
										'<div class="product-image">' +
											'<a href="{{itemUrl}}"><img src="{{itemThumbUrl}}" alt="{{itemTitle}}"></a>' +
										'</div>' +
  										'{{quickview}}' +
									'</div>' +
									'<div class="desc">' +
										'<h5><a href="{{itemUrl}}">{{itemTitle}}</a></h5>' +
										'{{itemProductType}}' +
										'<div class="price"style="font-size: 14px;">{{itemPrice}}</div>' +
										'{{itemReviews}}' +
									'</div>' +
									'<a class="tile-link" href="{{itemUrl}}" tabindex="-1" aria-hidden="true"></a>' +
								'</div>' +
							'</div>',

  	// List Template
	'productListItemHtml': '<div data-boost-theme-quickview="{{itemId}}" data-product-id="{{itemId}}" class="collection-list">' +
								'<div class="main_box">' +
									'<div class="box_1">' +
										'<div class="col-sm-4">' +
											'<div class="list-image">' +
												'<a href="{{itemUrl}}"><img src="{{itemThumbUrl}}" alt="{{itemTitle}}" class="img-responsive"></a>' +
											'</div>' +
  											'{{quickview}}' +
										'</div>' +
										'<div class="col-sm-8">' +
											'<div class="product-details">' +
												'{{itemSaleLabel}}' +
												'{{itemSoldOutLabel}}' +
												'<h2><a href="{{itemUrl}}">{{itemTitle}}</a></h2>' +
												'{{itemProductType}}' +
												'<p>{{itemDescription}}</p>' +
												'<div class="price">{{itemPrice}}</div>' +
												'{{itemAction}}' +
											'</div>' +
										'</div>' +
									'</div>' +
								'</div>' +
							'</div>',

  	// Pagination Template
	'previousActiveHtml': '<a href="{{itemUrl}}" class="prev"><span class="fa fa-chevron-left"></span>Previous</a>',
	'previousDisabledHtml': '<a href="" class="prev disabled"><span class="fa fa-chevron-left"></span>Previous</a>',
	'nextActiveHtml': '<a href="{{itemUrl}}" title="Next »" class="next">Next<span class="fa fa-chevron-right"></span></a>',
	'nextDisabledHtml': '<a href="" title="Next »" class="next disabled">Next<span class="fa fa-chevron-right"></span></a>',
	'pageItemHtml': '<li><a href="{{itemUrl}}" title="">{{itemTitle}}</a></li>',
	'pageItemSelectedHtml': '<li class="active"><a>{{itemTitle}}</a></li>',
	'pageItemRemainHtml': '<li><a href>{{itemTitle}}</a></li>',
	'paginateHtml': '{{previous}}<ul>{{pageItems}}</ul>{{next}}',

  	// Sorting Template
	'sortingHtml': '<span>{{sortingLabel}}:</span><div class="select_box sel_2"><select aria-label="Sort by" name="sortBy" id="sortBy" class="form-control">{{sortingItems}}</select></div>',
};

(function(){
	BoostPFS.inject(this);

    ProductGridItem.prototype.compileTemplate = function(data) {
        if (!data) data = this.data;
      
    	/*** Prepare data ***/
    	var images = data.images_info;
    	 // Displaying price base on the policy of Shopify, have to multiple by 100
    	var soldOut = !data.available; // Check a product is out of stock
    	var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
    	var priceVaries = data.price_min != data.price_max; // Check a product has many prices
    	// Get First Variant (selected_or_first_available_variant)
    	var firstVariant = data['variants'][0];
    	if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
    		var paramVariant = data.variants.filter(function(e) { return e.id == Utils.getParam('variant'); });
    		if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
    	} else {
    		for (var i = 0; i < data['variants'].length; i++) {
    			if (data['variants'][i].available) {
    				firstVariant = data['variants'][i];
    				break;
    			}
    		}
    	}
    	/*** End Prepare data ***/
    
    	// Get Template
    	var itemHtml = boostPFSTemplate.productGridItemHtml;
    
    	// Add class
    	itemHtml = itemHtml.replace(/{{itemOverlayClass}}/g, boostPFSConfig.custom.collection_overlay ? 'quick-view-overlay' : '');
    
    	// Add sale label
    	var itemSaleLabel = onSale ? boostPFSTemplate.saleLabel : '';
    	itemHtml = itemHtml.replace(/{{itemSaleLabel}}/g, itemSaleLabel);
    
    	// Add soldOut label
    	var itemSoldOutLabel = soldOut ? boostPFSTemplate.soldOutLabel : '';
    	itemHtml = itemHtml.replace(/{{itemSoldOutLabel}}/g, itemSoldOutLabel);
    
    	// Add Thumbnail
    	var itemThumbUrl = images.length > 0 ? Utils.optimizeImage(images[0]['src'], '800x') : boostPFSConfig.general.no_image_url;
    	itemHtml = itemHtml.replace(/{{itemThumbUrl}}/g, itemThumbUrl);
    
    	// Add Price
    	var itemPriceHtml = '';
    	if (priceVaries) {
    		itemPriceHtml += boostPFSConfig.label.from_price + ' ';
    	}
    	itemPriceHtml += '<span class="money">' + Utils.formatMoney(data.price_min, Globals.moneyFormat) + '</span>';
    	if (onSale) {
    		itemPriceHtml += '<span class="compare-price money">' + Utils.formatMoney(data.compare_at_price_min, Globals.moneyFormat) + '</span>';
    	}
    	itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);
    
    	// Add Product Type
    	var itemProductTypeHtml = boostPFSConfig.custom.show_grid_type ? '<p>' + data.product_type + '</p>' : '';
    	itemHtml = itemHtml.replace(/{{itemProductType}}/g, itemProductTypeHtml);
    
    	// Add Reviews
        if (typeof Integration === 'undefined' || !Integration.hascompileTemplate('reviews')) {
			var itemReviewsHtml = boostPFSConfig.custom.show_product_reviews_stars ? '<span class="shopify-product-reviews-badge min_height_22" data-id="{{itemId}}"></span><div class="clearfix"></div>' : '';
        	itemHtml = itemHtml.replace(/{{itemReviews}}/g, itemReviewsHtml);
		}    	
    	
      	// Add Quickview
      	itemHtml = itemHtml.replace(/{{quickview}}/g, buildQuickviewBtn());
      
    	// Add main attribute
    	itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
    	itemHtml = itemHtml.replace(/{{itemHtml}}/g, data.handle);
    	itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
    	itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrlWithVariant(data));
    
    	return itemHtml;
    }

    ProductListItem.prototype.compileTemplate = function(data) {
        if (!data) data = this.data;
        
    	/*** Prepare data ***/
    	var images = data.images_info;
    	 // Displaying price base on the policy of Shopify, have to multiple by 100
    	var soldOut = !data.available; // Check a product is out of stock
    	var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
    	var priceVaries = data.price_min != data.price_max; // Check a product has many prices
    	// Get First Variant (selected_or_first_available_variant)
    	var firstVariant = data['variants'][0];
    	if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
    		var paramVariant = data.variants.filter(function(e) { return e.id == Utils.getParam('variant'); });
    		if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
    	} else {
    		for (var i = 0; i < data['variants'].length; i++) {
    			if (data['variants'][i].available) {
    				firstVariant = data['variants'][i];
    				break;
    			}
    		}
    	}
    	/*** End Prepare data ***/
    
    	// Get Template
    	var itemHtml = boostPFSTemplate.productListItemHtml;
    
    	// Get First Variant
    	var firstVariant = data['variants'][0];
    	if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
    		var paramVariant = data.variants.filter(function(e) { return e.id == Utils.getParam('variant'); });
    		if (typeof paramVariant[0] !== 'undefined') {
    			firstVariant = paramVariant[0];
    		}
    	}
    
    	// Add sale label
    	var itemSaleLabel = onSale && boostPFSConfig.custom.show_sale_badge ? boostPFSTemplate.saleLabel : '';
    	itemHtml = itemHtml.replace(/{{itemSaleLabel}}/g, itemSaleLabel);
    
    	// Add soldOut label
    	var itemSoldOutLabel = soldOut ? boostPFSTemplate.itemSoldOutLabel : '';
    	itemHtml = itemHtml.replace(/{{itemSoldOutLabel}}/g, itemSoldOutLabel);
    
    	// Add Thumbnail
    	// var images = Object.keys(data.images).map(function (key) { return data.images[key]; });
    	var itemThumbUrl = images.length > 0 ? Utils.optimizeImage(images[0]['src']) : boostPFSConfig.general.no_image_url;
    	itemHtml = itemHtml.replace(/{{itemThumbUrl}}/g, itemThumbUrl);
    
    	// Add Product Type
    	var itemProductTypeHtml = boostPFSConfig.custom.show_grid_type ? '<p>' + data.product_type + '</p>' : '';
    	itemHtml = itemHtml.replace(/{{itemProductType}}/g, itemProductTypeHtml);
    
    	// Add Description
    	var itemDescription = jQ('<p>' + data.body_html + '</p>').text();
    	itemDescription = (itemDescription.split(" ")).length > 31 ? itemDescription.split(" ").splice(0, 31).join(" ") + '...' : itemDescription.split(" ").splice(0, 31).join(" ");
    	itemHtml = itemHtml.replace(/{{itemDescription}}/g, itemDescription);
    
    	// Add Price
    	var itemPriceHtml = '';
    	if (priceVaries) {
    		itemPriceHtml += boostPFSConfig.label.from_price + ' ';
    	}
    	itemPriceHtml += '<span class="money">' + Utils.formatMoney(data.price_min, Globals.moneyFormat) + '</span>';
    	if (onSale) {
    		itemPriceHtml += '<span class="compare-price money">' + Utils.formatMoney(data.compare_at_price_min, Globals.moneyFormat) + '</span>';
    	}
    	itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);
    
    	// Add Action
    	var itemActionHtml = '<form method="post" action="/cart/add">';
    	itemActionHtml += '<input type="hidden" name="id" value="' + firstVariant['id'] + '" />';
    	if (!soldOut && data.variants.length == 1) {
    		itemActionHtml += '<input type="submit" value="' + boostPFSConfig.label.add_to_cart + '" class="btn_c" />';        
    	}
    	itemActionHtml += '<a href="{{itemUrl}}" class="btn_c">' + boostPFSConfig.label.more_info + '</a>';
    	itemActionHtml += '</form>';
    	itemHtml = itemHtml.replace(/{{itemAction}}/g, itemActionHtml);
    
      	// Add Quickview
      	itemHtml = itemHtml.replace(/{{quickview}}/g, buildQuickviewBtn());
      
    	// Add main attribute
    	itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
    	itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
    	itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
    	itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrlWithVariant(data));
    
    	return itemHtml;
    }
    
    function buildQuickviewBtn(){
      	// Only emit the overlay when quick view is actually enabled - an empty
      	// overlay still covers the whole image and swallows clicks on it.
      	if (!boostPFSConfig.custom.collection_overlay) return '';
    	var html = '';
      	html += '<div class="btn-quickview overlay hidden-sm hidden-xs"></div>';
      	return html;
    }

	// Build Pagination
	ProductPaginationDefault.prototype.compileTemplate  = function(totalProduct) {
		if (!totalProduct) totalProduct = this.totalProduct;
		// Get page info
		var currentPage = parseInt(Globals.queryParams.page);
		var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);

		// If it has only one page, clear Pagination
		if (totalPage <= 1) {
			return '';
		}

		var paginationHtml = boostPFSTemplate.paginateHtml;

		// Build Previous
		var previousHtml = (currentPage > 1) ? boostPFSTemplate.previousActiveHtml : boostPFSTemplate.previousDisabledHtml;
		previousHtml = previousHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage - 1));
		paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);

		// Build Next
		var nextHtml = (currentPage < totalPage) ? boostPFSTemplate.nextActiveHtml :  boostPFSTemplate.nextDisabledHtml;
		nextHtml = nextHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage + 1));
		paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);

		// Create page items array
		var beforeCurrentPageArr = [];
		for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
			beforeCurrentPageArr.unshift(iBefore);
		}
		if (currentPage - 4 > 0) {
			beforeCurrentPageArr.unshift('...');
		}
		if (currentPage - 4 >= 0) {
			beforeCurrentPageArr.unshift(1);
		}
		beforeCurrentPageArr.push(currentPage);

		var afterCurrentPageArr = [];
		for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
			afterCurrentPageArr.push(iAfter);
		}
		if (currentPage + 3 < totalPage) {
			afterCurrentPageArr.push('...');
		}
		if (currentPage + 3 <= totalPage) {
			afterCurrentPageArr.push(totalPage);
		}

		// Build page items
		var pageItemsHtml = '';
		var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
		for (var iPage = 0; iPage < pageArr.length; iPage++) {
			if (pageArr[iPage] == '...') {
				pageItemsHtml += boostPFSTemplate.pageItemRemainHtml;
			} else {
				pageItemsHtml += (pageArr[iPage] == currentPage) ? boostPFSTemplate.pageItemSelectedHtml : boostPFSTemplate.pageItemHtml;
			}
			pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
			pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, pageArr[iPage]));
		}
		paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);

		return paginationHtml;
	};

	// Build Sorting
	ProductSorting.prototype.compileTemplate = function() {
		var html = '';
		if (boostPFSTemplate.hasOwnProperty('sortingHtml')) {
			var sortingArr = Utils.getSortingList();
			if (sortingArr) {
				// Build content
				var sortingItemsHtml = '';
				for (var k in sortingArr) {
					sortingItemsHtml += '<option value="' + k + '">' + sortingArr[k] + '</option>';
				}
				html = boostPFSTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml).replace(/{{sortingLabel}}/g, Labels.sorting);
			}
		}
		return html;
	};

	// Build Display type
	ProductDisplayType.prototype.compileTemplate = function() {
		var itemHtml = '<a href="' + Utils.buildToolbarLink('display', 'list', 'grid') + '" title="Grid view" class="btn btn-default change-view ml5 mr5 boost-pfs-filter-display-grid" data-view="grid"><i class="fa fa-lg fa-th"></i></a>';
    	itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'grid', 'list') + '" title="List view" class="btn btn-default change-view mr5 boost-pfs-filter-display-list" data-view="list"><i class="fa fa-lg fa-list"></i></a>';

		return itemHtml;
  	};

	// Add additional feature for product list, used commonly in customizing product list
	ProductList.prototype.afterRender = function(data) {
		if (boostPFSConfig.custom.collection_overlay){
    		// Build content for Quick view
            this.buildExtrasProductListByAjax(data, "boost-pfs", function(results){
                results.forEach(function(result, index){
                    // Append the custom html to product item
                  	jQ('[data-boost-theme-quickview="'+ result.id+ '"] .btn-quickview').append(result.quickshop_html);
                    if(index == results.length - 1){
                      enabledQuickView();
                    }
                })
            });	
    	}
    	
    	if (Globals.queryParams.display == 'list') {
    		jQ(Selector.products).removeClass('collection-grid');
    		jQ(Selector.products).addClass('row');
    	} else {
    		jQ(Selector.products).addClass('collection-grid');
    		jQ(Selector.products).removeClass('row');
    	}
	};

    FilterTree.prototype.afterRender = function() {
        var _this = this;
        _this.filterOptions.forEach((filterOption) => {
			if (filterOption.displayType == 'range' && filterOption.filterType == 'price') {
                setTimeout(function(){
                    filterOption.$element.find('.noUi-value-horizontal').each(function(){
                        var num = jQ(this).text().replace(/\./g, '').replace(/\,/g, '');
                        if (parseInt(num) == parseInt(Math.round(filterOption.rangeMin)) || parseInt(num) == parseInt(Math.round(filterOption.rangeMax))) {
                            var length = num.toString().length;
                            var zero = '1';
                            while(zero.length < length) {
                              zero = zero + '0';
                            }
                            var count = parseInt(num) / parseInt(zero);
                            if (parseInt(num) == parseInt(Math.round(filterOption.rangeMin))) {
                                count = Math.floor(count) * parseInt(zero);
                            }
                            if (parseInt(num) == parseInt(Math.round(filterOption.rangeMax))) {
                                count = Math.ceil(count) * parseInt(zero);
                            }
                            jQ(this).text(count);
                        }
                    })
                }, 500)
			}
		})
    }

	// Build Additional Elements
	Filter.prototype.afterRender = function(data) {
		if (!data) data = this.data;
	}

    
})();
